module.exports = __webpack_public_path__ + "img/58cef21.jpg";